import type { ApiRoute, NoBody, NoQueryParams } from "../../api"
import type { DocumentResponse } from "../../common"

export interface GenerateEnergyEfficiencyLabelPathParams {
	inventoryId: string
}
export const generateEnergyEfficiencyLabelRoute: ApiRoute<
	GenerateEnergyEfficiencyLabelPathParams,
	NoQueryParams,
	NoBody,
	DocumentResponse
> = {
	buildUrl: (params) => `/vehicles/${params.inventoryId}/energy-efficiency-label`,
	method: "get",
	path: "/vehicles/:inventoryId/energy-efficiency-label",
}
